import React from "react";

const Afterword = () => {
  return (
    <div className="center-container">
        <div className="article-body">
          <p className="subheader">后记</p>
          <div className="spacerdiv"/>
          <p>在整理无差别袭击案件数据时，每个案件都让歪脑感到惋惜。我们失去的，有年幼的儿童，即将步入社会的大学生, 妈妈, 有退伍军人, 退休老人....这些无妄之灾中的幸免者, 他们往后的一生也要学会与创伤后应激障碍（PTSD）共存。还有无数受害者家庭，他们一夜之间成了“失独父母”, 没了至亲, 陷在愤怒和恐惧的漩涡中无法自拔。但同时，我们失去的，还有数百位袭击者, 他们并非社会十恶不赦的毒瘤，他们有的是背井离乡的农民工，是公车司机，是儿子、爸爸....他们也是社会体制的受害者，在孤独和偏执中走向绝路。也许，一只援助的手、一双聆听的耳朵、一句安慰与劝诫，就能阻止一些悲剧的发生。</p>
          <p>因中国司法不公开，官方数据不完整不透明等现实阻碍，文章中引用的少量数据，是民间组织整理，歪脑无法完全核实其数据的完整性和准确性。关于无差别袭击事件，还有很多是我们不能回答的。但歪脑希望通过本次报道，穿透这些冷冰冰的数据，让大家看到背后每个真实的个体。关注它，理解它，会是改变的第一步，也是最重要的一步。</p>

          <div className="spacerdiv__tall" />
          <div style={{ borderBottom:"0.5px solid var(--yellow)", width:"100%", display:"block" }} />
          <div className="spacerdiv" />

          
          <div className="methodology">
            <p style={{ color:"var(--yellow)", fontSize:"1.2rem" }}>方法论</p>
            <p>歪脑使用“滚雪球”的方式收集和整理了2000年以来中国新闻媒体报道中公共场合的“无差别”、“随机”袭击事件。</p>
  
            <p>我们参考台北大学法学专家周愫娴的定义，将无差别袭击事件定义为公共场所中孤独个体对陌生人的暴力行为。依据这个定义，我们最终整理出2000年到2024年，中国发生的141起无差别袭击事件。</p>
  
            <p>首先，歪脑参考有关无差别袭击事件的文章，如“2018年至2024年中国滥杀滥伤案件<a href="https://chinadigitaltimes.net/chinese/713007.html" target="_blank">汇总分析</a>”和维基百科对中国袭击事件的记录，并查阅了在线资源，如中国被判处死刑的<a href="https://jykss.com/" target="_blank">人名单</a>，编制了无差别袭击事件列表。然后，歪脑通过百度搜索检索到的新闻媒体报道，来验证列表中的每一起袭击事件，并从报道中获取更多无差别袭击事件的案例。</p>
  
            <p>歪脑从新闻媒体报道中收集了案例的详细信息，包括 犯罪嫌疑人的个人信息, 暴力形式, 暴力发生的时间和地点, 官方发布的攻击动机, 伤亡人数，和法庭判决等。歪脑还对比参照了美国东北大学和美联社<a href="https://data.world/associatedpress/mass-killings-public" target="_blank">发表</a>的“美国大规模袭击事件（2006年-2024）”中符合无差别袭击事件定义的案例，一共75起。日本和台湾没有无差别袭击事件的数据库，歪脑也通过“滚雪球”的方式根据日本和台湾学者的相关研究，搜索新闻媒体的报道，收集整理了2000年到2024年18起发生在日本的15起发生在台湾的无差别袭击事件的数据。根据台湾学者研究，最早的无差别袭击事件发生在2009年。</p>
            <div className="spacerdiv" />

            <p style={{ fontSize:"0.65rem", opacity:"0.7" }}>图片来源：RFA、Reuters (Brenda Goh, Tingshu Wang)、X (@whyyoutouzhele)、联合早报（黎康）、百度地图、澎湃新闻（谭君）、新黃河 濟南日報、Kyodo News、现代快报
            </p>

            <div className="spacerdiv__tall" />

            <div className="credits">
              <p>数据编辑：<b>吴拾</b></p>
              <p>文字记者：<b>刘艺</b></p>
              <p>网页设计/制作：<b>Regina Li</b></p>
              <p style={{ letterSpacing:"1px" }}>3/21/2025</p>
              
            </div>
            

            <div className="spacerdiv__tall" />

          </div>



        </div>
    </div>
  )
}

export default Afterword